module.exports = __webpack_public_path__ + "media/images/common/btn-notice-off-212d8adf082f95e750f54825a149db76.svg";